import TableTab from './TableTab';
import connectContainer from './TableTabContainer';

export default connectContainer(TableTab);
